import { Sprite, Texture } from 'pixi.js';
import { random } from 'lodash';
import vars from '../vars';
import Actor from './Actor';
import Fuel from './Fuel';
import Hole from './Hole';
import Jump from './Jump';
import Obstacle from './Obstacle';
import state from '../state';
import Powerup from './Powerup';

class Block extends Actor {
  constructor(parent, player, descriptor) {
    super(parent);
    this.player = player;
    this.descriptor = descriptor;
    this.content = [];

    this.sprite = new Sprite();
    this.container = new Sprite(Texture.WHITE);
    this.container.renderable = false;

    this.resize();
    this.sprite.addChild(this.container);
    this.parent.addChild(this.sprite);

    this.parse();
  }

  resize() {
    this.container.width = vars.layout.GRID_UNIT * this.descriptor.width;
    this.container.height = vars.layout.GRID_UNIT * this.descriptor.height;

    this.sprite.position.y = vars.layout.FRAME_HEIGHT + 100; // Max sprite height 200
    this.sprite.position.x = vars.layout.GRID_UNIT * random(0, 8 - this.descriptor.width, false);
  }

  parse() {
    this.descriptor.grid.forEach((column, i) => {
      column.forEach((row, k) => {
        let current;
        switch (row.id) {
          case 'fuel':
            if (random(0, 1, true) <= (row.probability || 0.5)) {
              current = new Fuel(this.sprite, this.player);
            }
            break;
          case 'hole':
            current = new Hole(this.sprite, this.player, row.type);
            break;
          case 'jump':
            current = new Jump(this.sprite, this.player);
            break;
          case 'obstacle':
            current = new Obstacle(this.sprite, this.player, row.mode, row.width);
            break;
          case 'powerup':
            if (!state.activePowerup && random(0, 1, true) < row.probability && !state.hasPowerupOnStage) {
              current = new Powerup(this.sprite, this.player);
              state.hasPowerupOnStage = true;
            } else {
              current = new Fuel(this.sprite, this.player);
            }
            break;

          default:
            break;
        }
        if (current) {
          current.sprite.position.x = (vars.layout.GRID_UNIT * k) + (vars.layout.GRID_UNIT / 2);
          current.sprite.position.y = (vars.layout.GRID_UNIT * i) + (vars.layout.GRID_UNIT / 2);
          if (typeof current.afterPlace === 'function') { current.afterPlace(); }
          this.content.push(current);
        }
      });
    });
  }

  destroy() {
    this.content.forEach((c) => c.destroy());
    this.sprite.destroy({ children: true });
  }
}

export default Block;
